@let infoConfig = infoButtonConfig();
<article class="flex flex-col gap-y-2">
  <div class="flex items-center">
    <h2 class="text-xl font-bold">{{ sectionTitle() }}</h2>

    <ng-content></ng-content>

    <div class="flex items-center gap-2 ml-3">
      @if (showNoteButton()) {
        <div class="w-[110px]">
          <icon-button
            icon="note"
            label="Add note"
            variant="secondary"
            size="sm"
            class="w-full"
            (click)="noteClick.emit()" />
        </div>
      }

      @if (infoConfig) {
        <div class="w-[80px]">
          <app-info-button
            [infoText]="infoConfig.info"
            [infoTitle]="infoConfig.title"
            [tooltipPosition]="'right'"
            [asButton]="true" />
        </div>
      }
    </div>
  </div>
  @if (isSectionLocked()) {
    <app-dashboard-alert
      type="info"
      message="This section is locked. You can only view the information" />
  }
</article>
